<cap-content-header>
  <cap-title>
    {{ "gefundeneGemeinden" | translate }}
  </cap-title>
  @if (listLoader) {
    <cap-title-functionbar>
      <cap-functionbar-searchresult-buttons [listLoader]="listLoader"></cap-functionbar-searchresult-buttons>
    </cap-title-functionbar>
  }
</cap-content-header>

<div class="my-4">
  @if (listLoader) {
    <div>
      <cap-list-loader [listLoader]="listLoader">
        <div class="cap-list-loader-title">
          <ng-content select="[name=title]"></ng-content>
        </div>
        <div class="cap-list-loader-content">
          <table class="cap-table-search">
            <thead>
              <ng-template [ngTemplateOutlet]="tableHeaders"></ng-template>
            </thead>
            <tbody>
              <ng-template [ngTemplateOutlet]="tableRows"></ng-template>
            </tbody>
          </table>
        </div>
      </cap-list-loader>
    </div>
  } @else {
    <cap-spinner-small></cap-spinner-small>
  }
</div>

<ng-template #tableHeaders>
  <tr>
    <th>
      {{ "Name" | translate }}
    </th>
    <th>
      {{ "Art" | translate }}
    </th>
    <th>
      {{ "suchergebnis.gemeinden.PolitischeGemeinde" | translate }}
    </th>
    <th>
      {{ "Nummer" | translate }}
    </th>
    <th>
      {{ "Gemeinde.Kuerzel" | translate }}
    </th>
    @if (hasPermissionPlan && isMapsLinkConfigured) {
      <th>
        {{ "Plan" | translate }}
      </th>
    }
  </tr>
</ng-template>

<ng-template #tableRows>
  @for (item of listLoader?.items; track item) {
    <tr>
      <td>
        @if (item.gbGemeinde?.id?.id) {
          <cap-link
            [params]="[item.gbGemeinde.id.id]"
            [target]="navTargets.NAV_GEMEINDE_GB"
            [tooltipParams]="{ name: item.gbGemeinde?.name | translateName }">
            {{ item.object.name | translateName }}
          </cap-link>
        }
      </td>
      <td>
        {{ item.object.gemeindeArt | translate }}
      </td>
      <td>
        {{ item.politischeGemeinde?.name }}
      </td>
      <td>
        @if (item.object.bfsNummer) {
          {{ item.object.bfsNummer }}
          @if (item.object.kreisNummer) {
            <span>.{{ item.object.kreisNummer }}</span>
          }
        }
        @if (!item.object.bfsNummer && item.object.auslGemNr) {
          {{ item.object.auslGemNr }}
        }
      </td>
      <td>
        {{ item.object.kuerzel }}
      </td>
      @if (hasPermissionPlan && isMapsLinkConfigured) {
        <td>
          @if (item.plan) {
            <cap-maps
              [mapType]="'gemeinde'"
              [model]="item.object"
              [tooltip]="(item.object.gemeindeArt | translate) + ' ' + item.politischeGemeinde?.name"></cap-maps>
          }
        </td>
      }
    </tr>
  }
</ng-template>
